
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class EventService  {

  private eventSubject = new Subject<any>();
  event$ = this.eventSubject.asObservable();
  
  publish(event: any) {
    this.eventSubject.next(event);
  }

  receivedMsg(): Observable<any> {
    return this.eventSubject.asObservable();
  }

}
